<div class="credit-limit-box" *ngIf="showOverdue">
    <div class="credit-limit-section-title" *ngIf="kind === 'both'">Credit Limit 4 – Overdue days</div>
    <div class="credit-limit-row">
        <span class="credit-limit-row__label">
            <i class="pi pi-calendar" aria-hidden="true"></i>
            Overdue days (NOOD)
        </span>
        <strong>{{ nood }}</strong>
    </div>
    <div class="credit-limit-row">
        <span class="credit-limit-row__label">
            <i class="pi pi-sliders-h" aria-hidden="true"></i>
            Credit Limit 4 (ODUD)
        </span>
        <strong>{{ odud }}</strong>
    </div>
</div>

<div class="credit-limit-box" *ngIf="showExposure">
    <div class="credit-limit-section-title" *ngIf="kind === 'both'">Credit Limit 3 – Amount</div>
    <div class="credit-limit-row">
        <span class="credit-limit-row__label">
            <i class="pi pi-wallet" aria-hidden="true"></i>
            Outstanding
        </span>
        <strong>{{ data!.outstanding | number: '1.2-2' }}</strong>
    </div>
    <div class="credit-limit-row">
        <span class="credit-limit-row__label">
            <i class="pi pi-shopping-cart" aria-hidden="true"></i>
            Order value
        </span>
        <strong>{{ data!.orderValue | number: '1.2-2' }}</strong>
    </div>
    <div class="credit-limit-row">
        <span class="credit-limit-row__label">
            <i class="pi pi-credit-card" aria-hidden="true"></i>
            Credit limit
        </span>
        <strong>{{ data!.creditLimit | number: '1.2-2' }}</strong>
    </div>
    <div class="credit-limit-row credit-limit-total">
        <span class="credit-limit-row__label">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            Exceeds limit by
        </span>
        <strong>{{ data!.exceedBy | number: '1.2-2' }}</strong>
    </div>
</div>

<p class="credit-limit-note credit-limit-note--footer" *ngIf="note">
    <i class="pi pi-info-circle credit-limit-note__icon" aria-hidden="true"></i>
    <span>
        {{ noteIntro }}
        <span class="credit-limit-contact-emails" *ngIf="contactEmails.length">
            <strong *ngFor="let email of contactEmails">{{ email }}</strong>
        </span>
    </span>
</p>
